import { useMemo } from "react";
import { useRows } from "../lib/db";

/** The paired till's business installed_modules as a Set, from the local copy of core.businesses. */
export function useInstalledModules(businessId: string | null): Set<string> {
  const result = useRows("businesses", "SELECT * FROM businesses WHERE id = $1", [businessId ?? ""]);
  return useMemo(() => new Set((result?.rows[0]?.installed_modules ?? []).filter((m) => m !== "")), [result]);
}
